<input type="file" class="upload" [hidden]="true" id="fileUp" name="fileUpload" onchange="setFileInfo(this.files)">

<div [style.display]="ShowReadyFile ? 'none ' : 'block'">
  <div class="is-fullheight">
    <div class="hero-body">
      <div class="container-tab">
        <div class="columns is-multiline">
          <div class="column is-8 is-offset-2">
            <div class="drop-container" [ngClass]="{'active': isDragOver}" (dragover)="isDragOver = true"
              (dragleave)="isDragOver = false" ngFileDrop [options]="options" (uploadOutput)="onUploadOutput($event)"
              [uploadInput]="uploadInput">
              <div>
                Drag a file here or
                <label class="upload-button">
                  <input type="file" #fileInput ngFileSelect [options]="options" (uploadOutput)="onUploadOutput($event)"
                    [uploadInput]="uploadInput" multiple (click)="fileInput.value = null"> browse
                </label>
                to upload.
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="tab-footer tab-footer--upload d-flex justify-content-end">
    <button class="mr-3" type="button" mat-raised-button (click)="cancel()" mat-flat-button
      matTooltip="Cancel">Cancel</button>
  </div>
</div>

<div class='container-tab uploaded-file-tab' *ngIf="ShowReadyFile">

  <file *ngFor="let playlistItem of playlistItems; let i = index; trackBy: trackByIndex"
    [playlist]="playlist"
    [playlistItem]="playlistItem"
    [playlistItems]="playlistItems"
    [itemIndex]="i"
    [launchers]="launchers"
    [savedSelectedLauncher]="selectedLaunchers[i]"
    [uploadInput]="uploadInput"
    [recentFiles$]="recentFiles$"
    [hasRssForegroundItem]="hasRssForegroundItem"
    (changeLauncher)="onLauncherChange($event.launcher, false, $event.item)"
    (uploadOutput)="onUploadOutput($event, false)"
    (removeItem)="onRemoveItem(i)"
    (changeSourceField)="onChangeSourceField($event)"
    (changeSourceData)="onChangeSourceData($event)"
    (changeMCLMode)="onChangeMode($event)"
    (determineDuration)="onDetermineDuration($event)"
    (initDurations)="onInitDurations($event)"
    (updateRecentFiles)="recentFiles$ = $event"
    (setSelectedLauncherForAllItems)="onSetLauncherForAllItems($event, playlistItemTypes.UploadFile)"
    (zoomInputChanged)="onZoomInputChanged($event.event, $event.item.PlaylistItemLinks[$event.sourceId])"
    (stretchContentChanged)="onStretchContentChanged($event)">
  </file>

  <mat-toolbar class="tab-footer unset">
    <mat-checkbox *ngIf="!playlistItems[0].Id" [disableRipple]="true" [(ngModel)]="addAnother" name="addAnother"
      class="light" matTooltip="Add one more item to the Playlist">Add Another</mat-checkbox>

    <button type="button" mat-raised-button (click)="cancel()" mat-flat-button matTooltip="Cancel">Cancel</button>
    <button [disabled]="percentage < appConts.FULLY_DOWNLOADED_FILE || (playlistItems | isAnyPlaylistItemProcessing: timeSpan)"
      type="submit" (click)="submit()" mat-flat-button matTooltip="Save">Save</button>
  </mat-toolbar>

</div>
